import { FC } from 'react';
import styles from './../../index.module.scss';
import classNames from 'classnames';
interface Params {
  children?: any;
  bold?: boolean;
}
export const Underline: FC<Params> = (props) => {
  return (
    <span
      className={classNames(styles.underLine, props.bold ? styles.bold : '')}
    >
      {props.children}
    </span>
  );
};
